import { useCallback, useState, useEffect } from 'react';
export var useCommentManager = function useCommentManager(_ref) {
  var _preview$id, _preview$position;

  var comments = _ref.comments,
      setComments = _ref.setComments;

  var _useState = useState(null),
      preview = _useState[0],
      setPreview = _useState[1];

  var _useState2 = useState(false),
      isEditingComment = _useState2[0],
      setIsEditingComment = _useState2[1];

  var _useState3 = useState(''),
      commentValue = _useState3[0],
      setCommentValue = _useState3[1];

  var hoveredCommentId = (_preview$id = preview === null || preview === void 0 ? void 0 : preview.id) !== null && _preview$id !== void 0 ? _preview$id : null;
  var popupPosition = (_preview$position = preview === null || preview === void 0 ? void 0 : preview.position) !== null && _preview$position !== void 0 ? _preview$position : null;
  useEffect(function () {
    if (hoveredCommentId) {
      var comment = comments.find(function (c) {
        return c.id === hoveredCommentId;
      });

      if (comment && comment.content !== commentValue) {
        setCommentValue(comment.content || '');
      }
    }
  }, [comments, hoveredCommentId]);
  var handleCommentActivated = useCallback(function () {
    return undefined;
  }, []);
  var showCommentPreview = useCallback(function (nextPreview) {
    var comment = comments.find(function (item) {
      return item.id === nextPreview.id;
    });
    if (!comment) return;
    setPreview(nextPreview);
    setCommentValue(comment.content || '');
  }, [comments]);
  var closeCommentPreview = useCallback(function () {
    setPreview(null);
    setIsEditingComment(false);
    setCommentValue('');
  }, []);
  var handleCommentEdit = useCallback(function () {
    setIsEditingComment(true);
    var comment = comments.find(function (c) {
      return c.id === hoveredCommentId;
    });
    setCommentValue((comment === null || comment === void 0 ? void 0 : comment.content) || '');
  }, [comments, hoveredCommentId]);
  var handleCommentDelete = closeCommentPreview;
  var handleCommentUpdate = closeCommentPreview;
  var handleCancelUpdateComment = closeCommentPreview;
  return {
    comments: comments,
    preview: preview,
    hoveredCommentId: hoveredCommentId,
    popupPosition: popupPosition,
    isEditingComment: isEditingComment,
    setIsEditingComment: setIsEditingComment,
    commentValue: commentValue,
    handleCommentActivated: handleCommentActivated,
    showCommentPreview: showCommentPreview,
    handleCommentEdit: handleCommentEdit,
    handleCommentDelete: handleCommentDelete,
    handleCommentUpdate: handleCommentUpdate,
    handleCancelUpdateComment: handleCancelUpdateComment,
    closeCommentPreview: closeCommentPreview,
    setCommentValue: setCommentValue,
    setComments: setComments
  };
};